module.exports = __webpack_public_path__ + "static/media/doctor.144ea611.jpg";